import React from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import moment from "moment";
import DataGrid, { Column, HeaderFilter, Paging, Pager } from "devextreme-react/ui/data-grid";
import validaciones from "../../../../../helpers/validaciones";

class TablaAprobadores extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <div className="contenedor-master-detail">
          <DataGrid
            dataSource={this.props.data.Approvers}
            noDataText=""
            className="custom-table"
            showBorders={false}
            showColumnLines={false}
            allowColumnResizing={false}
            columnAutoWidth={false}
            showRowLines={false}
            rowAlternationEnabled
            onContentReady={(e) => {
              if (e.component.totalCount() === 0) {
                const config = {};
                config.addClass = "table-margin";
                const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
                const element = validaciones.noDataDOMElement(config, "Sin Información");
                noDataSpan.appendChild(element);
              }
            }}
          >

              <Column
                alignment="center"
                dataField="Rut"
                caption="Aprobador"
              />

              <Column
                alignment="center"
                dataField="UserRegistered"
                caption="Usuario registrado"
                cellTemplate={(element, row) => {
                  ReactDOM.render(
                    <i className="mantenedor-empresa-icon achs-icon"> {row.data.UserRegistered ? 'X' : 'W' } </i>
                    , element
                  );
                }}
              />

              <Column
                alignment="center"
                dataField="CreationDate"
                caption="Creador"
                cellTemplate={(element, row) => {
                  ReactDOM.render(
                    <div>
                      <div>
                        {row.data.Author}
                      </div>
                      <div>
                        {moment(row.data.CreationDate).format("DD/MM/YYYY")}
                      </div>
                    </div>
                    , element
                  );
                }}
              />

          <Paging
            defaultPageSize={4}
          />

          <Pager
            showNavigationButtons
            showInfo
            infoText={(page, total) => `Página ${page} de ${total}`}
          />
          </DataGrid>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.mantenedorEmpresas.isLoading,
  listaEmpresas: state.mantenedorEmpresas.listaEmpresas,
  listaEmpresasFiltradas: state.mantenedorEmpresas.listaEmpresasFiltradas,
  filtrosEmpresas: state.mantenedorEmpresas.filtrosEmpresas,
  empresa: state.mantenedorEmpresas.empresa
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TablaAprobadores);
